import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/store';
import { Product, Project } from '../utils/model';
import { multilabProductsRaw, productAll } from './products';
import { getGroupProjects } from '../gitlabApi/gqlApi/getGroupProjects';
import { getProjectInfoGql } from '../gitlabApi/gqlApi/getProjectInfoGql';
import { setProjects } from '../redux/productSlice';

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

let multilabProducts: Product[] = [];
let allProjects: Project[] = [];

let raceCondition = false;
export const initProducts = async () => {
  try {
    while (raceCondition) await sleep(500);
    raceCondition = true;
    if (multilabProducts.length > 0) {
      return { products: multilabProducts, allProjects, err: undefined };
    }
    multilabProducts = await Promise.all(
      multilabProductsRaw.map<Promise<Product>>(async (p) => {
        const directProjects: Project[] = [];
        const projects: Project[] = [];
        if (p.projectPaths.length > 0) {
          const innerProjects = await Promise.all(p.projectPaths.map(getProjectInfoGql));
          const filteredProjects: Project[] = innerProjects.filter(
            (p) => !!p,
          ) as Project[];
          projects.push(...filteredProjects);
          directProjects.push(...filteredProjects);
        }
        if (p.groupPaths.length > 0 && p.name !== productAll) {
          const groupProjects = await Promise.all(p.groupPaths.map(getGroupProjects));
          projects.push(...groupProjects.flat());
        }
        const res: Product = {
          name: p.name,
          projects,
          directProjects,
          groupPaths: p.groupPaths,
          pmProjectPath: p.pmProjectPath,
        };
        return res;
      }),
    );
    const generalProduct = multilabProducts.find((p) => p.name === productAll);
    if (generalProduct) {
      const allProjectsCandidates = [
        ...multilabProducts
          .filter((p) => p.name !== productAll)
          .flatMap((p) => p.projects),
      ];
      for (const project of allProjectsCandidates) {
        const existing = allProjects.find((p) => p.id === project.id);
        if (!existing) {
          allProjects.push(project);
        }
      }
      generalProduct.projects = allProjects;
    }
    return { products: multilabProducts, allProjects, err: undefined };
  } catch (err: any) {
    return { products: [], allProjects: [], err: err.message as string };
  } finally {
    raceCondition = false;
  }
};

export const useProducts = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [error, setError] = useState<string | undefined>();
  const [loading, setLoading] = useState(false);
  const dispatch = useAppDispatch();

  const user = useAppSelector((s) => s.user.user);

  useEffect(() => {
    const act = async () => {
      if (!user?.username) return;
      setLoading(true);
      const { products, allProjects, err } = await initProducts();
      setProducts([...products]);
      dispatch(setProjects(allProjects));
      setError(err);
      setLoading(false);
    };
    act();
  }, [user?.username, dispatch]);

  return { products, error, loading };
};
